import http from "../../core/services/http.service";

const ReturnNotesService = {
  getReturnNotes(params) {
    return http.get(`/api/v1/inventories/return-notes/`, {params});
  },
  getReturnNoteByUuid(uuid, params) {
    return http.get(`/api/v1/inventories/return-notes/${uuid}/`, {params});
  },
};

export default ReturnNotesService;
